module.exports = __webpack_public_path__ + "img/ksbIcon.600c2863.png";